export const getCookieDomain = () => {
  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    return '.canopyweather.com';
  }
  if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
    return '.canopyweather.net';
  }
  return 'localhost';
};
